export enum applicationName {
  BACKOFFICE = "BACKOFFICE",
  CLIENT = "CLIENT",
}
